<template lang="html">
  <div class="md:pl-4">
  <div class="bg-white p-8 shadow-lg rounded text-gray-700">
    <span class="mb-4 block border-b pb-4">
      <i class="fas fa-user-tag text-xl mr-2"></i>
      <span class="text-xl">Role Breakdown</span>
      <!-- Tabs -->

      <div class="block">
        <a :class="{ 'bg-heroyellow text-white' : tab === activetab }" @click="activetab = tab" v-for="(tab,i) in tabs" v-bind:key="i" class="inline-block text-xs border rounded px-1 mr-1 border-b-0">{{tab}}</a>
      </div>

    </span>

    <div v-if="activetab == 'All Users'">
      <div v-for="(role,i) in roles" v-bind:key="i">
        <span class="pb-2">{{role.name}}</span>
        <span class="float-right">{{percentage( role.name )}}</span>
        <span class="bg-gray-400 h-4 block mb-4">
          <span :style="'width:'+ percentage( role.name )" class="bg-heroyellow h-full block"></span>
        </span>
      </div>
    </div>

    <div v-if="activetab == 'Completed'">
      <div v-for="(role,i) in roles" v-bind:key="i">
        <span class="pb-2">{{role.name}}</span>
        <span class="float-right">{{compPercentage( role.name )}}</span>
        <span class="bg-gray-400 h-4 block mb-4">
          <span :style="'width:'+ compPercentage( role.name )" class="bg-heroyellow h-full block"></span>
        </span>
      </div>
    </div>

    <div v-if="activetab == 'Incomplete'">
      <div v-for="(role,i) in roles" v-bind:key="i">
        <span class="pb-2">{{role.name}}</span>
        <span class="float-right">{{incompletePercentage( role.name )}}</span>
        <span class="bg-gray-400 h-4 block mb-4">
          <span :style="'width:'+ incompletePercentage( role.name )" class="bg-heroyellow h-full block"></span>
        </span>
      </div>
    </div>



  </div>
  </div>
</template>

<script>
  export default {
   data() {
     return {
       tabs: ["All Users","Completed","Incomplete"],
       activetab: "Completed",
       roles: [
        { name: "CEC" },
        { name: "Commercial" },
        { name: "Digital & IT" },
        { name: "Directors" },
        { name: "Finance (inc Estates & Audit)" },
        { name: "HR" },
        { name: "Logistics (GMM)" },
        { name: "Marketing" },
        { name: "Safety Services" },
       ],
     }
   },
   computed: {
     herosCompleted() {
       let users = this.$attrs.users
       let heros = this.$attrs.heros
       let result = []
       users.forEach(user => {
         heros.forEach(hero => {
           if(hero.uid == user.uid){
             result.push({
               email: user.email,
               hero: hero.number,
               role: user.role
             })
           }
         });
       });
       return result
     },

     herosInCompleted() {
       let users = this.$attrs.users
       let heros = this.$attrs.heros
       let result = []
       users.forEach(user => {
         heros.forEach(hero => {
           if(hero.uid != user.uid){
             result.push({
               email: user.email,
               hero: hero.number,
               role: user.role
             })
           }
         });
       });
       return result
     },
     herosCompletedCount() {
       var heros = this.$attrs.heros.length
       return heros
     }
   },
   methods: {
     percentage( i ) {
       let res = []
       this.$attrs.users.forEach(item => {
         if(item.role.name == i){
         //console.log(i, item)
         res.push(item)
         }
       });
       return (Math.round(res.length * 100 / this.$attrs.users.length) + '%')
     },
      compPercentage( i ) {
        let res = []
        this.herosCompleted.forEach(item => {
          if(item.role.name == i){
          //console.log(i, item)
          res.push(item)
          }
        });
        return (Math.round(res.length * 100 / this.herosCompletedCount) + '%')
      },

      incompletePercentage( i ) {
        let res = []
        this.herosInCompleted.forEach(item => {
          if(item.role.name == i){
          //console.log(i, item)
          res.push(item)
          }
        });
        return (Math.round(res.length * 100 / this.herosInCompleted.length) + '%')
      }
   }
  }
</script>
